import { Icon } from "../../General/Icon";
import { OcrState } from "../../../Models/UploadState";
import { Snap } from "../../../Models/Snap";


export class OcrIcon extends Icon
{
    constructor(snap: Snap)
    {
        super("document_scanner", "lightblue");
        this.Class("ocr-button");

        snap.OcrState.OnChange(ocrState =>
        {
            const stateToColor = {
                [OcrState.NoOcr]: "#fff",
                [OcrState.Started]: "yellow",
                [OcrState.Ready]: "lightgreen",
                [OcrState.Error]: "red"
            }

            this.Color(stateToColor[ocrState]);
        });

        this.OnClick(() =>
        {
            snap.ObtainOcrText();
        });
    }
}
